import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
export var captureException = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(error, packageName, tags) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return");
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function captureException(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();